import { ComponentProps } from 'react'

import {
  Objectclass,
  StandardMultiselection
} from '@yes.technology/react-toolkit'

import { useSiteState } from 'siteState/shared'

import { useFetchYesObjects } from 'yesObject/shared'

import { ArrayFieldValue } from '../../types'

import {
  SelectionOption,
  parseObjectsToOptions,
  parseOptionsToObjects
} from './optionsParser'

type StandardMultiselectionProps = ComponentProps<typeof StandardMultiselection>

export type SelectionMenuOption = {
  id: string
  value: string
  collapsable?: boolean
  collapsed?: boolean
  label?: string
  uuid?: string
}

type StandardMultiselectionFieldProps = {
  onChangeValues: (values: ArrayFieldValue) => void
  selectedOptions: ArrayFieldValue
  filteractionUuid: string
} & Partial<Omit<StandardMultiselectionProps, 'selectedOptions'>>

const StandardMultiselectionField = ({
  onChangeValues,
  selectedOptions: selectedObjects,
  filteractionUuid,
  heightClass,
  ...props
}: StandardMultiselectionFieldProps) => {
  const [objectclass] = useSiteState<Objectclass | undefined>(
    'filter-objectclass'
  )

  const { yesObjects, isFetching } = useFetchYesObjects({
    filteractionUuid,
    initialPagination: { limit: 300, offset: 0 },
    showLoading: false,
    interpolationObject: objectclass
  })

  const onSelect = (newSelectedOption: SelectionMenuOption) => {
    let newSelectedOptions: SelectionMenuOption[]

    if (selectedOptions.some((option) => option.id === newSelectedOption.id)) {
      newSelectedOptions = selectedOptions.filter(
        (option) => option.id !== newSelectedOption.id
      )
    } else {
      newSelectedOptions = [...selectedOptions, newSelectedOption]
    }

    onChangeValues(
      parseOptionsToObjects(newSelectedOptions as SelectionOption[])
    )
  }

  if (typeof selectedObjects === 'string') {
    return null
  }

  const options = parseObjectsToOptions(yesObjects)

  const selectedOptions = parseObjectsToOptions(selectedObjects)

  return (
    <StandardMultiselection
      {...props}
      options={options}
      selectedOptions={selectedOptions}
      onSelect={onSelect}
      statusClass={isFetching ? 'processing' : 'default'}
      heightClass={heightClass || 'regular'}
    />
  )
}

export default StandardMultiselectionField
